// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2v-Mg","itemTitle":"ClientEmergencyInfo_itemTitle__3YOnQ","itemText":"ClientEmergencyInfo_itemText__2nFEj"};